import { Input as _Input, InputProps as _InputProps } from "reactstrap";

    export const Input = _Input;
    export type InputProps = _InputProps;
    